import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Button, Confirm } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import { reduxForm, getFormValues, Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { createSubDistrict, updateSubDistrict } from 'ducks/dataManagement'

import r from 'reactotron-react-js'

const SubDistrictModal = (props) => {
  const { valueForm, onClose } = props

  const [showConfirmDelete, setShowConfirmDelete] = useState(false)
  const [showConfirmSave, setShowConfirmSave] = useState(false)

  return (
    <Dialog open={true} maxWidth='md' style={{ zIndex: 10 }}>
      <DialogTitle>Sub District</DialogTitle>
      <DialogContent>
        <form>
          <Field name='nameTh' require label='Name TH' type={type.text} component={FieldInput} />
          <Field name='nameEn' label='Name EN' type={type.text} component={FieldInput} />
          <Field name='zipCode' label='Zip Code' type={type.text} component={FieldInput} />
        </form>
      </DialogContent>
      <DialogActions>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', padding: '0px 15px' }} >
          <div>
            {
              // valueForm.id ? 
              //   <Button
              //     type='button'
              //     content='Delete'
              //     color='red'
              //     icon='trash alternate'
              //     labelPosition='right'
              //     style={{ marginRight: '5px' }}
              //     onClick={() => setShowConfirmDelete(true) }
              //   /> : null
            }
          </div>
          <div>
            {
              valueForm.id ? 
                <Button
                  type='button'
                  content='Update'
                  color='blue'
                  icon='save'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => setShowConfirmSave(true)}
                /> : 
                <Button
                  type='button'
                  content='Create'
                  color='blue'
                  icon='paper plane outline'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => setShowConfirmSave(true)}
                />
            }
            <Button
              type='button'
              content='Cancel'
              color='red'
              icon='times'
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={() => onClose()}
            />
          </div>
        </div>
      </DialogActions>
      <Confirm 
        open={showConfirmDelete}
        content='Are you sure to delete this sub district.'
        onConfirm={() => props.deleteSubDistrict(
          valueForm.id, 
          () => {
            setShowConfirmDelete(false)
            onClose()
          })
        }
        onCancel={() => setShowConfirmDelete(false)}
      />
      <Confirm 
        open={showConfirmSave}
        content={`Are you sure to ${valueForm.id ? 'update' : 'create'} this sub district.`}
        onConfirm={() => {
          if (valueForm.id) { // UPDATE
            props.updateSubDistrict(valueForm, () => onClose())
          } else { // CREATE
            props.createSubDistrict(valueForm, () => onClose())
          }
        }}
        onCancel={() => setShowConfirmSave(false)}
      />
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const { data, districtId, provinceId } = props
  const editData = data || {}
  const valueForm = getFormValues('subDistrictForm')(state) || {}
  
  return ({
    initialValues: {
      id: editData.id,
      nameTh: editData.nameTh,
      nameEn: editData.nameEn,
      code: editData.code,
      zipCode: editData.zipCode,
      districtId: editData.districtId || districtId,
      provinceId: provinceId
    },
    valueForm: valueForm,
  })
}

const mapDispatchToProps = {
  createSubDistrict,
  updateSubDistrict
}

const SubDistrictModalForm = reduxForm({
  form: 'subDistrictForm',
  enableReinitialize: true,
})(SubDistrictModal)

export default connect(mapStateToProps, mapDispatchToProps)(SubDistrictModalForm)